// Treatment (behandling) page content

export const TREATMENTS_CONTENT = {
  dermapen: {
    slug: "dermapen",
    category: "Hudforbedring",
    h1: "Dermapen i Oslo",
    metaTitle: "Dermapen Oslo | Klinisk microneedling for arr & hudfornyelse – Medskinby",
    metaDescription:
      "Klinisk Dermapen-behandling for aknearr, fine linjer og hudfornyelse. Erfarne hudterapeuter på Frogner, Oslo. Book online.",
    lead:
      "Dermapen er en presisjons-microneedling som stimulerer hudens egen reparasjon og kollagenproduksjon. Resultatet er fastere, jevnere og friskere hud.",
    paragraphs: [
      "Behandlingen lager mikroskopiske kanaler i huden som trigger en naturlig reparasjonsprosess. Vi kombinerer ofte med vekstfaktorer eller polynukleotider for forsterket effekt.",
      "Spesielt effektiv mot aknearr, store porer, fine linjer og generell hudkvalitet.",
    ],
    forWhom: [
      "Aknearr og atrofiske arr",
      "Store porer og ujevn hudstruktur",
      "Fine linjer og redusert fasthet",
      "Glødløs hud som trenger fornyelse",
    ],
    relatedIssues: ["akne-arr-uren-hud", "anti-age-hudfornyelse", "hormonell-ubalanse"],
    faq: [
      { q: "Hvor mange behandlinger trenger jeg?", a: "3–6 behandlinger med 4 ukers mellomrom for optimalt resultat." },
      { q: "Er det smertefullt?", a: "Vi bruker kremebedøvelse. De fleste opplever lett ubehag, ikke smerte." },
      { q: "Hvor lang nedetid?", a: "1–3 dager med lett rødme. De fleste er sosialt presentable etter 24 timer." },
    ],
  },
  microneedling: {
    slug: "microneedling",
    category: "Hudforbedring",
    h1: "Microneedling i Oslo",
    metaTitle: "Microneedling Oslo | Kollagenstimulering – Medskinby",
    metaDescription:
      "Klinisk microneedling for aknearr, glød og hudfornyelse. Trygg, dokumentert behandling i Oslo.",
    lead:
      "Microneedling stimulerer hudens egen kollagenproduksjon gjennom kontrollerte mikronåler. Resultatet er strammere, jevnere og mer ungdommelig hud.",
    paragraphs: [
      "Vi tilpasser dybde og protokoll til ditt hudmål – akne, arr, anti-age eller barrierebygging.",
      "Microneedling kan kombineres med PRP, mesoterapi eller polynukleotider for å forsterke effekten.",
    ],
    forWhom: [
      "Akne og aknearr",
      "Fine linjer og rynker",
      "Pigmentering og ujevn hudtone",
      "Svekket hudbarriere",
    ],
    relatedIssues: ["akne-arr-uren-hud", "anti-age-hudfornyelse", "hudbarriere"],
    faq: [
      { q: "Forskjellen mellom Dermapen og microneedling?", a: "Dermapen er et spesifikt utstyrsmerke innen microneedling. Vi tilpasser valg av utstyr til ditt hudmål." },
      { q: "Hvor ofte kan jeg ta behandlingen?", a: "Hver 4–6 uke i en initial kur, deretter vedlikehold." },
    ],
  },
  hydrafacial: {
    slug: "hydrafacial",
    category: "Ansiktsbehandling",
    h1: "Hydrafacial i Oslo",
    metaTitle: "Hydrafacial Oslo | Premium ansiktsbehandling – Medskinby",
    metaDescription:
      "Hydrafacial-behandling for glød, hydrering og dyprens. Trygg, behagelig og synlig effekt. Frogner, Oslo.",
    lead:
      "HydraFacial er en kompromissløs ansiktsbehandling utviklet for huden som krever både dyprens og dyp pleie – i samme protokoll. Synlig glød allerede idet du forlater klinikken.",
    paragraphs: [
      "På få minutter renser, eksfolierer, ekstraherer og hydrerer behandlingen huden – med målrettede serum som leveres direkte inn i porene. Det som gjør HydraFacial unik er kombinasjonen av klinisk presisjon og total komfort. Behandlingen tilpasses alle hudtyper – fra sensitiv og reaktiv hud til moden hud med behov for fornyelse – uten nedetid og uten irritasjon.",
      "Hos Medskinby har vi utviklet våre egne signaturprotokoller rundt HydraFacial-teknologien, slik at hver behandling er skreddersydd dine spesifikke hudmål: ren, balansert hud – eller den klare «glass skin»-gløden som varer.",
    ],
    forWhom: [
      "Alle hudtyper – også sensitiv og reaktiv hud",
      "Glødløs, sliten hud som trenger reset",
      "Uren hud og tette porer",
      "Dehydrert hud med svekket hudbarriere",
      "Pre-event glow før bryllup, ferie og viktige anledninger",
    ],
    packages: [
      {
        name: "HydraFacial Signatur",
        subtitle: "Klassisk",
        price: "1 740 kr",
        duration: "35 min",
        description:
          "Vår klassiske og mest etterspurte behandling. En skånsom, dyprensende og fuktighetsgivende ansiktsbehandling som passer alle hudtyper og gir umiddelbare resultater uten ubehag eller nedetid. Inkluderer en næringsrik avsluttende maske som forsegler effekten.",
      },
      {
        name: "HydraFacial Glass Skin Glow",
        subtitle: "Oppgradert glød",
        price: "995 kr",
        originalPrice: "1 980 kr",
        badge: "Kampanje",
        duration: "45 min",
        description:
          "Den perfekte behandlingen før ferie, bryllup, eventer eller når huden trenger en full reset. Vår oppgraderte versjon av Signatur kombinerer skreddersydd peel, LED-lysterapi og dypvirkende etterpleie for en intensiv, klar glød og den ettertraktede «glass skin»-effekten. Tilpasset hudtype og behov.",
      },
      {
        name: "HydraFacial Premium",
        subtitle: "Signatur med skreddersydd booster",
        price: "1 300 kr",
        originalPrice: "2 300 kr",
        badge: "Kampanje",
        duration: "55 min",
        description:
          "Vår mest helhetlige HydraFacial. Premium inkluderer en skreddersydd booster som målretter spesifikke hudbehov – aldringstegn, pigmentering, akne eller sensitivitet – og avsluttes med næringsrik maske og LED-lysterapi for maksimal effekt og healthy glow.",
      },
    ],
    images: {
      hero: "https://customer-assets.emergentagent.com/job_welcome-stage-8/artifacts/sl38ff3s_IMG_6529.jpeg",
      gallery: [
        {
          src: "https://customer-assets.emergentagent.com/job_welcome-stage-8/artifacts/5dcymtmc_IMG_5822.jpeg",
          alt: "Hydrafacial behandling i detalj – Medskinby Oslo",
          caption: "Presisjonsbehandling",
        },
        {
          src: "https://customer-assets.emergentagent.com/job_welcome-stage-8/artifacts/g7e63h00_IMG_6530.jpeg",
          alt: "Hydrafacial i klinikkens private rom",
          caption: "Rolig atmosfære",
        },
        {
          src: "https://customer-assets.emergentagent.com/job_welcome-stage-8/artifacts/7gy1fm41_IMG_6012.jpeg",
          alt: "Pasient under Hydrafacial-behandling",
          caption: "Klinisk presisjon",
        },
      ],
      result: {
        src: "https://customer-assets.emergentagent.com/job_welcome-stage-8/artifacts/n0dnwi3a_IMG_5815.jpeg",
        alt: "Resultat etter Hydrafacial – glød og jevnere hud",
        label: "Resultat etter behandling",
      },
    },
    relatedIssues: ["akne-arr-uren-hud", "sensitiv-hud", "hudbarriere", "rosacea-inflammasjon"],
    faq: [
      { q: "Er det nedetid?", a: "Ingen. Du kan gå direkte tilbake til hverdagen – mange tar HydraFacial rett før et viktig event nettopp av denne grunnen." },
      { q: "Hvor ofte bør jeg ta HydraFacial?", a: "Hver 4–6 uke for vedvarende glød og hudkvalitet. Mange velger månedlig vedlikehold." },
      { q: "Passer det for sensitiv hud?", a: "Ja. HydraFacial er en av de mest skånsomme dyprensebehandlingene som finnes, og kan tilpasses også reaktiv hud." },
      { q: "Hvilken variant bør jeg velge?", a: "Signatur er perfekt som vedlikehold, Glass Skin Glow før viktige anledninger, og Premium for målrettet effekt på spesifikke hudutfordringer." },
    ],
  },
  profhilo: {
    slug: "profhilo",
    category: "Injeksjon",
    h1: "Profhilo i Oslo",
    metaTitle: "Profhilo Oslo | Biostimulator for hudkvalitet – Medskinby",
    metaDescription:
      "Profhilo-behandling for fastere, friskere hud. Hyaluronsyre-injeksjon for hudkvalitet, ikke volum. Klinisk i Oslo.",
    lead:
      "Profhilo er en biostimulator som forbedrer hudens kvalitet innenfra. Mer fasthet, mer glød, jevnere struktur – uten å endre ansiktstrekk.",
    paragraphs: [
      "Profhilo gir hyaluronsyre direkte til huden og stimulerer egen kollagen- og elastinproduksjon. Resultatet er hud som ser ut som hud – bare friskere.",
      "Brukes ofte i ansikt, hals og dekolleté. Ikke filler – ingen volum, ingen forandring av trekk.",
    ],
    forWhom: [
      "Hud som mister glød og fasthet",
      "Dehydrert moden hud",
      "Hals og dekolleté",
      "Forebyggende anti-age",
    ],
    relatedIssues: ["anti-age-hudfornyelse", "hudbarriere"],
    faq: [
      { q: "Hvor mange behandlinger?", a: "Standardprotokoll er 2 behandlinger med 4 ukers mellomrom, deretter vedlikehold hver 6.–12. måned." },
      { q: "Endrer det ansiktstrekkene?", a: "Nei. Profhilo gir hudkvalitet, ikke volum." },
    ],
  },
  tannbleking: {
    slug: "tannbleking",
    category: "Tannbleking",
    h1: "Tannbleking i Oslo",
    metaTitle: "Tannbleking Oslo | Kampanjepris 1 999 kr – Medskinby",
    metaDescription:
      "Profesjonell tannbleking i Oslo hos Medskinby. Individuell vurdering, skånsom og effektiv behandling for et naturlig lysere smil. Kampanjepris 1 999 kr.",
    lead:
      "Et smil du føler deg trygg på å vise frem. Er du en av dem som skjuler smilet når det tas bilder? Kaffe, te, brus og andre ytre faktorer kan over tid bidra til misfarging av tennene – du trenger ikke leve med et smil du ikke føler deg komfortabel med.",
    paragraphs: [
      "Hos Medskinby tilbyr vi profesjonell tannbleking med fokus på trygghet, individuell vurdering og et naturlig lysere resultat. Et lysere smil kan gi et friskere uttrykk og gjøre at du føler deg mer komfortabel med å smile – både i hverdagen og på bilder.",
      "Tannblekingen er utviklet for å redusere synlig misfarging og gi tennene et lysere og renere utseende på en skånsom og effektiv måte. Målet er ikke et unaturlig hvitt smil, men et resultat som passer deg og utgangspunktet ditt.",
    ],
    forWhomTitle: "Derfor velger våre kunder oss",
    forWhom: [
      "Individuell vurdering før behandlingen",
      "Utføres av autoriserte behandlere",
      "Skånsom og effektiv behandling",
      "Synlig lysere tenner etter behandlingen",
      "Veiledning om vedlikehold av resultatet",
      "Perfekt før ferie, bryllup, fest eller spesielle anledninger",
    ],
    packages: [
      {
        name: "Tannbleking",
        subtitle: "Kampanjepris – begrenset antall plasser",
        price: "1 999 kr",
        badge: "Kampanje",
        duration: "45 min",
        description:
          "Vår komplette kliniske tannbleking. Vi starter med en individuell vurdering, tilpasser styrken til dine tenner og ditt utgangspunkt, og gjennomfører behandlingen med fokus på et trygt og naturlig resultat. Du får veiledning om hvordan du best mulig kan ta vare på resultatet. Når kampanjeplassene er fylt opp, gjelder ordinær pris.",
      },
    ],
    causes: {
      title: "Hvorfor blir tennene misfarget?",
      lead: "Tennene utsettes hver dag for ulike faktorer som kan påvirke fargen. Tannbleking kan bidra til å redusere synlig misfarging og gi et lysere uttrykk.",
      items: [
        { title: "Kaffe & te", description: "Kan over tid bidra til ytre misfarging av emaljen." },
        { title: "Brus & drikker", description: "Kan påvirke tennenes overflate og farge over tid." },
        { title: "Mat & pigmenter", description: "Mange typer mat og drikke inneholder pigmenter som bidrar til misfarging." },
        { title: "Tid & aldring", description: "Det er naturlig at tannfargen endrer seg over årene." },
      ],
    },
    processSteps: {
      title: "Slik sikrer du deg kampanjeprisen",
      steps: [
        { title: "Book din time", description: "Reserver time direkte via Timma. Du velger et tidspunkt som passer for deg." },
        { title: "Individuell vurdering", description: "Vi vurderer tennene og bekrefter at behandlingen passer for deg før vi går videre." },
        { title: "Behandling & veiledning", description: "Tannbleking utføres i klinikken, og du får veiledning om vedlikehold og etterbehandling." },
      ],
    },
    images: {
      hero: "https://customer-assets-jai6qajn.emergentagent.net/job_welcome-stage-8/artifacts/0juy0pp5_IMG_9268.jpeg",
      gallery: [
        {
          src: "https://customer-assets-jai6qajn.emergentagent.net/job_welcome-stage-8/artifacts/4co96wyf_IMG_9273.webp",
          alt: "Tannbleking utført av autorisert behandler ved Medskinby Oslo",
          caption: "Klinisk presisjon",
        },
        {
          src: "https://customer-assets-jai6qajn.emergentagent.net/job_welcome-stage-8/artifacts/l9gamhcp_IMG_9266.webp",
          alt: "Individuell fargevurdering med skala før tannbleking",
          caption: "Individuell vurdering",
        },
        {
          src: "https://customer-assets-jai6qajn.emergentagent.net/job_welcome-stage-8/artifacts/fcqg1g51_IMG_9265.webp",
          alt: "Resultat etter tannbleking – naturlig lysere smil",
          caption: "Naturlig resultat",
        },
      ],
      clientPhotos: [
        {
          src: "https://customer-assets-jai6qajn.emergentagent.net/job_welcome-stage-8/artifacts/jsauwbt2_IMG_9274.jpeg",
          alt: "Ekte kunde etter tannbleking hos Medskinby",
        },
        {
          src: "https://customer-assets-jai6qajn.emergentagent.net/job_welcome-stage-8/artifacts/14zoz3sz_IMG_9272.webp",
          alt: "Fornøyd kunde med lysere smil",
        },
        {
          src: "https://customer-assets-jai6qajn.emergentagent.net/job_welcome-stage-8/artifacts/w7wndzb2_IMG_9275.jpeg",
          alt: "Behandlingsrom hos Medskinby",
        },
        {
          src: "https://customer-assets-jai6qajn.emergentagent.net/job_welcome-stage-8/artifacts/2yu9mzyv_IMG_9269.jpeg",
          alt: "Kunde smiler etter tannbleking",
        },
        {
          src: "https://customer-assets-jai6qajn.emergentagent.net/job_welcome-stage-8/artifacts/eunpjvyv_IMG_9270.webp",
          alt: "Naturlig lysere smil etter behandling",
        },
      ],
    },
    faq: [
      {
        q: "Er tannbleking trygt?",
        a: "Før behandlingen gjør vi en individuell vurdering og gir deg informasjon om behandlingen og hva du kan forvente. Behandlingen utføres av autoriserte behandlere med dokumenterte produkter.",
      },
      {
        q: "Hvor mye lysere blir tennene?",
        a: "Resultatet varierer fra person til person og avhenger blant annet av utgangspunktet og hvilken type misfarging du har. Målet er et lysere og naturlig resultat.",
      },
      {
        q: "Kan alle bleke tennene?",
        a: "Ikke nødvendigvis. Derfor gjennomfører vi en individuell vurdering før behandlingen for å sikre at det er et godt valg for akkurat deg.",
      },
      {
        q: "Hvor lenge varer resultatet?",
        a: "Det varierer fra person til person. Kosthold, kaffe, te, røyking og andre faktorer kan påvirke hvor raskt tennene får tilbake noe av sin opprinnelige farge.",
      },
      {
        q: "Kan jeg få tannbleking før en spesiell anledning?",
        a: "Ja – tannbleking er et populært valg før ferie, bryllup, fest eller fotografering. Vi anbefaler likevel at du ikke legger behandlingen helt opp mot anledningen, slik at du har god tid til etterbehandling og veiledning.",
      },
    ],
  },
};
